/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMessagesBanner = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M6 9h5V7H6zm6 4H6v-2h6zm-6 5h5v-2H6zm12 0h-5v-2h5zm-.707-7.293-1.236-1.236-1.236 1.236-1.414-1.414 1.236-1.236-1.35-1.35 1.414-1.414 1.35 1.35 1.35-1.35 1.414 1.414-1.35 1.35 1.236 1.236z" />
        <path d="M22 2H2v20h20zM4 20V4h16v16z" />
      </g>
    </g>
  </Icon>
);
export { SvgMessagesBanner as MessagesBanner };
